export default __webpack_public_path__ + "static/media/noti.41ee4f57.png";